import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop, Ref } from "@eastsideco/salvo-ts";
import mediumZoom, { ZoomOpenOptions } from 'medium-zoom';
import { Console } from "console";
import Swiper, { SwiperOptions } from "swiper";
import { SwiperEvents } from "swiper/types/swiper-events";
import { SwiperModule } from "swiper/types/shared";


@Component
export class ImgZoom extends ThemeComponent {
    @Ref zoomable!: HTMLImageElement[];
    @Ref zoomBtn!: HTMLElement[];
    init() {
        const zoom = mediumZoom('[data-zoomable]', {
            background:'rgba(0, 0, 0, 0.6)'
        });
        for(const btn of this.zoomBtn) {
            this.$listen(btn, 'click', () => {
                const imgIdentifier = btn.getAttribute('data-associated-img-identifier') as string | '';
                // eslint-disable-next-line
                const associatedImg = document.querySelector(`img[data-img-identifier=${imgIdentifier}]`);
                this.$log.info(`${associatedImg}`);
                if(associatedImg) {
                    const zoomOptions = {
                        target: associatedImg
                    } as ZoomOpenOptions;
                    // eslint-disable-next-line
                    zoom.open(zoomOptions);   
                }
                this.$listen( btn, 'change', () => {
                    // eslint-disable-next-line
                    zoom.close();
                });
            });

        }
    }

}
